import { memo, ReactNode } from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';

interface ConfirmationModalViewProps {
  readonly header: string;
  readonly body: ReactNode;
  readonly confirmLabel: string;
  readonly isConfirming: boolean;
  readonly onDismiss: () => void;
  readonly onConfirm: () => void;
  /** When false, hides the Cancel button and ignores backdrop / Esc dismissals. Used during a non-recoverable retry flow where Cancel would lose work. */
  readonly isDismissible?: boolean;
  /** When true, disables the confirm button. Used to block confirming while the body is invalid. */
  readonly isConfirmDisabled?: boolean;
}

const ConfirmationModalView = memo(function ConfirmationModalView({
  header,
  body,
  confirmLabel,
  isConfirming,
  onDismiss,
  onConfirm,
  isDismissible = true,
  isConfirmDisabled = false,
}: ConfirmationModalViewProps) {
  return (
    <Modal
      visible
      header={header}
      onDismiss={isDismissible && !isConfirming ? onDismiss : () => undefined}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            {isDismissible && (
              <Button variant="link" onClick={onDismiss} disabled={isConfirming}>
                Cancel
              </Button>
            )}
            <Button
              variant="primary"
              loading={isConfirming}
              disabled={isConfirmDisabled}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {body}
    </Modal>
  );
});

export default ConfirmationModalView;
